import * as Yup from "yup";

const marcaValidator = Yup.object().shape({
  nome: Yup.string().required("Nome"),
  ativado: Yup.boolean().optional().nullable(),
});

export default marcaValidator;
